import React from 'react'

const Page404 = () => {
  return (
    <main>
      <h1 id="main-content-title" tabIndex="-1">404 - page not found</h1>
    </main>
  )
}

export default Page404